var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPressing(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.754,
    height: 26.894,
    viewBox: "0 0 32.754 26.894",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_51",
    "data-name": "Groupe 51",
    transform: "translate(1.005)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Icon_awesome-tshirt",
    "data-name": "Icon awesome-tshirt",
    d: "M29.089,4.382,20.116,0c-.926,1.262-2.977,2.143-5.369,2.143S10.3,1.262,9.377,0L.4,4.382a.727.727,0,0,0-.332.976l2.636,5.2a.748.748,0,0,0,.991.327L6.308,9.626a.736.736,0,0,1,1.06.654V21.795a1.462,1.462,0,0,0,1.475,1.453h11.8a1.462,1.462,0,0,0,1.475-1.453V10.275a.737.737,0,0,1,1.06-.654l2.609,1.258a.74.74,0,0,0,.991-.327l2.641-5.194a.72.72,0,0,0-.327-.976Z",
    transform: "translate(0.004 2.646)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "customStroke",
    id: "Icon_weather-stars",
    "data-name": "Icon weather-stars",
    d: "M6.444,10.331A.957.957,0,0,0,7.13,10a1.066,1.066,0,0,0,.283-.739A1.062,1.062,0,0,0,7.691,10a.957.957,0,0,0,.686.33.957.957,0,0,0-.686.33,1.062,1.062,0,0,0-.278.739,1.047,1.047,0,0,0-.283-.739A.957.957,0,0,0,6.444,10.331Zm.968-3.166a1.867,1.867,0,0,0,1.334-.646,2.076,2.076,0,0,0,.549-1.442,2.076,2.076,0,0,0,.549,1.442,1.885,1.885,0,0,0,1.338.646,1.852,1.852,0,0,0-.952.312,2.067,2.067,0,0,0-.686.761,2.163,2.163,0,0,0-.249,1.025,2.087,2.087,0,0,0-.549-1.447A1.855,1.855,0,0,0,7.412,7.165ZM8.792,11.9A1.4,1.4,0,0,0,9.8,11.418a1.562,1.562,0,0,0,.411-1.086,1.562,1.562,0,0,0,.411,1.086,1.389,1.389,0,0,0,1,.484,1.389,1.389,0,0,0-1,.484,1.562,1.562,0,0,0-.411,1.086A1.562,1.562,0,0,0,9.8,12.385,1.422,1.422,0,0,0,8.792,11.9Zm2.83-2.085a1.389,1.389,0,0,0,1-.484,1.562,1.562,0,0,0,.407-1.091,1.562,1.562,0,0,0,.411,1.086,1.4,1.4,0,0,0,1.006.484,1.4,1.4,0,0,0-1.006.484,1.562,1.562,0,0,0-.411,1.086,1.578,1.578,0,0,0-.407-1.086A1.4,1.4,0,0,0,11.622,9.817Z",
    transform: "translate(17.292 -5.076)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.4
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPressing);
export default __webpack_public_path__ + "static/media/icon-pressing.2b41cdd04c6e986636d9c3004f6e7fa4.svg";
export { ForwardRef as ReactComponent };